<template>
  <div class="syb-list-page">
    <div class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>书影币授权列表</div>
    </div>
    <div class="top-bg-st"></div>
    <div class="my-item list-title">
      <div class="my-lab">书影币授权记录：</div>
    </div>
    <!--<div class="syb-item title-clr">-->
      <!--<div class="title-clr-c">-->
        <!--<div style="border-right: 1px solid #eee">用户名</div>-->
        <!--&lt;!&ndash;<div style="border-right: 1px solid #eee">用户ID</div>&ndash;&gt;-->
        <!--<div style="border-right: 1px solid #eee">卡类型</div>-->
        <!--<div style="flex:1">申请理由</div>-->
      <!--</div>-->
    <!--</div>-->
    <div v-if="!sybList.length" class="content-box" style="padding-top: 1rem;text-align: center;">暂无记录</div>
    <div  v-if="sybList.length" class="content-box"  v-bottom-load="{handle: getHY, distance: 30}">
      <div class="syb-item" v-for="(item,index) in sybList">
        <div class="list-item-left">
          <div class="item-top"> {{item.content}}</div>
          <div class="item-bottom">分发时间 : {{timeFormat(item.create_time)}}</div>
        </div>
        <div style="padding-right: 20px">{{item.number}} 个</div>
      </div>
    </div>



  </div>
</template>

<script>
  export default {
    name: "sybList",
    data() {
      return {
        sybList: '',
        total: '',
        page: 0,
        key: true,
        end: false,
      }
    },
    mounted() {
      this.getHY();
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1);
      },

      getHY() {
        if (this.key && !this.end) {
          this.key = false;
          this.$http.post('symx', {
            token: window.localStorage.getItem('token'),
            limit: 20,
            page: this.page,
          }).then(
            (res) => {
              this.key = true;
              if (res.data.code == 200) {
                this.sybList = [...this.sybList, ...res.data.data.info];
                this.total = res.data.data.total;
                this.page++;
                this.end = !!(20 * this.page >= this.total)
              }else {
                this.$toast(res.data.msg || "系统错误");
              }
            }, (e) => {
              this.key = true;
            }
          )
        }
      },
    }
  }
</script>

<style lang="scss">

  .syb-list-page {
    .top-bg-st {
      position: relative;
      height: 2.4rem;
      width: 7.5rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
    }

    .list-title {
      position: fixed;
      top: 1.24rem;
      left: 0;
      right: 0;
      color: #999999;
      font-size: .28rem;
      background: #ffffff;
      width: 6.86rem;
      margin: .24rem auto 0;
      height: .84rem;
      border-top-right-radius: .32rem;
      border-top-left-radius: .32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .32rem;
      box-sizing: border-box;
    }

    .title-clr {
      position: fixed;
      top: 2.1rem;
      left: 0;
      right: 0;
      overflow: auto;
      color: #999999;
      background: #ffffff;
      width: 6.86rem;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 0 .24rem;
      .title-clr-c {
        height:.72rem;display: flex;align-items: center;border-top: 1px solid #ebedf0;
        border-bottom: 1px solid #ebedf0;
      }

    }
    .content-box {
      padding-left: .24rem;
      padding-right: .24rem;
      position: fixed;
      top: 2.2rem;
      left: 0;
      right: 0;
      bottom: .8rem;
      overflow: auto;
      color: #999999;
      background: #ffffff;
      border-bottom-right-radius: .32rem;
      border-bottom-left-radius: .32rem;
      width: 6.86rem;
      padding-bottom: 1.6rem;
      box-sizing: border-box;
      margin: 0 auto;
    }

    .syb-item {
      height: 1.2rem;
      border-bottom: 1px solid #ebedf0;
      padding-left: .4rem;
      color: #999999;
      font-size: .32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .list-item-left {
        display: flex;
        flex-direction: column;

        .item-top {
          font-size: .28rem;
          margin-bottom: .08rem;
        }

        .item-bottom {
          font-size: .16rem;
        }
      }

      div {
        white-space: nowrap;
      }
    }

  .my-item {
      height: .72rem;
      border-bottom: 1px solid #ebedf0;
      line-height: .72rem;
      padding-left: .4rem;
      color: #999999;
      display: flex;
      align-items: center;
      font-size: .26rem;

      .my-lab {
        width: 100%;
      }
    }


  }

</style>














// WEBPACK FOOTER //
// src/components/sybList.vue